module.exports = __webpack_public_path__ + "static/img/culture1.0ebeba8a.png";